var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8086 7.57227L7.90486 7.57227L7.90485 10.1238C7.90485 10.9257 8.55488 11.5757 9.35672 11.5757C10.1586 11.5757 10.8086 10.9257 10.8086 10.1238L10.8086 7.57227Z",
    fill: "url(#paint0_linear_284_25051)",
    stroke: "url(#paint1_linear_284_25051)",
    strokeWidth: 0.30481
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 9.33158C10.7234 9.27459 10.69 9.22541 10.6391 9.20552C10.3502 9.09253 9.66076 8.835 9.04695 8.69676C8.73835 8.62726 8.45816 8.59017 8.25952 8.61187C8.16008 8.62273 8.09126 8.64734 8.04917 8.68058C8.01151 8.71031 7.98891 8.75162 7.99004 8.81859C7.99618 9.18284 7.99771 9.66164 7.99723 10.1176C7.99644 10.8743 8.60754 11.4908 9.36337 11.4908C10.1145 11.4908 10.7234 10.8819 10.7234 10.1308L10.7234 9.33158Z",
    fill: "#AD916F",
    stroke: "url(#paint2_linear_284_25051)",
    strokeWidth: 0.170388
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 13.8047H8.69426",
    stroke: "url(#paint3_linear_284_25051)",
    strokeWidth: 0.340776,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35645 13.8047L9.3564 11.5756",
    stroke: "url(#paint4_linear_284_25051)",
    strokeWidth: 0.340776,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55938 0C4.37126 0 4.21875 0.152507 4.21875 0.340633V3.74097C3.6141 4.00446 3.19141 4.60741 3.19141 5.30909V13.5809C3.19141 13.7547 3.3221 13.9004 3.49517 13.9166C3.85425 13.9503 4.45883 13.9999 4.90114 13.9999C5.34345 13.9999 5.94802 13.9503 6.30711 13.9166C6.48017 13.9004 6.61087 13.7547 6.61087 13.5809V5.30909C6.61087 4.59092 6.16807 3.97617 5.54059 3.72296V0.340632C5.54059 0.152506 5.38808 0 5.19995 0H4.55938Z",
    fill: "url(#paint5_linear_284_25051)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 0.340632C4.21875 0.152506 4.37126 0 4.55938 0H5.19995C5.38808 0 5.54059 0.152506 5.54059 0.340632V2.17736H4.21875V0.340632Z",
    fill: "#AD916F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 1.64258H5.43883",
    stroke: "url(#paint6_linear_284_25051)",
    strokeWidth: 0.227088,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 1.19141H5.43883",
    stroke: "url(#paint7_linear_284_25051)",
    strokeWidth: 0.227088,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.19141,
    y: 6.60449,
    width: 3.41946,
    height: 4.82015,
    fill: "#AD916F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_25051",
    x1: 9.35672,
    y1: 7.57227,
    x2: 9.35672,
    y2: 11.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_25051",
    x1: 9.35672,
    y1: 7.57227,
    x2: 9.35672,
    y2: 11.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_25051",
    x1: 9.3567,
    y1: 8.52051,
    x2: 9.3567,
    y2: 11.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_284_25051",
    x1: 9.35689,
    y1: 13.8047,
    x2: 9.35689,
    y2: 12.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_284_25051",
    x1: 9.35642,
    y1: 12.6902,
    x2: 10.3564,
    y2: 12.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_284_25051",
    x1: 4.90114,
    y1: 0,
    x2: 4.90114,
    y2: 13.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_284_25051",
    x1: 4.88543,
    y1: 1.64258,
    x2: 4.88543,
    y2: 2.64258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_284_25051",
    x1: 4.88543,
    y1: 1.19141,
    x2: 4.88543,
    y2: 2.19141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.dedf5cc2350ab4dd9b9568145231596d.svg";
export { ForwardRef as ReactComponent };